var axios = require('axios');

export default class MainService {

    constructor() {
        var token = JSON.parse(localStorage.getItem('token'));
        axios.defaults.baseURL = process.env.VUE_APP_MAIN_SERVICE;
        if (token) {
            axios.defaults.headers.common = {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } else {
            axios.defaults.headers.common = {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }
    }

    getToken() {
        return axios.defaults.headers.common;
    }

    login(item) {
        return axios.post('api/login', item);
    }

    renovePassword(item){
        return axios.post('api/renovePassword', item);
    }

    uploadFile(item) {
        return axios.post('api/uploadFile', item);
    }

    loginToken365(item) {
        return axios.post('api/loginToken365', item);
    }

    indexPersona() {
        return axios.defaults.baseURL + 'api/Persona/index';
    }

    showPersona(id) {
        return axios.get('api/Persona/show?id=' + id);
    }

    listPersona() {
        return axios.get('api/Persona/list');
    }

    storePersona(item) {
        return axios.post('api/Persona/store', item);
    }

    destroyPersona(item) {
        return axios.post('api/Persona/destroy', item);
    }

    select2Persona(q) {
        return axios.get('api/Persona/select2?q=' + q);
    }

    changePassword(item) {
        return axios.post('api/Persona/changePassword', item);
    }

    showUnidadAcademica(id) {
        return axios.get('api/UnidadAcademica/show?id=' + id);
    }

    indexUnidadAcademica() {
        return axios.defaults.baseURL + 'api/UnidadAcademica/index';
    }

    listUnidadAcademica() {
        return axios.get('api/UnidadAcademica/list');
    }

    storeUnidadAcademica(item) {
        return axios.post('api/UnidadAcademica/store', item);
    }

    destroyUnidadAcademica(item) {
        return axios.post('api/UnidadAcademica/destroy', item);
    }

    showRol(id) {
        return axios.get('api/Rol/show?id=' + id);
    }

    indexRol() {
        return axios.defaults.baseURL + 'api/Rol/index';
    }

    listRol() {
        return axios.get('api/Rol/list');
    }

    storeRol(item) {
        return axios.post('api/Rol/store', item);
    }

    destroyRol(item) {
        return axios.post('api/Rol/destroy', item);
    }

    storeLogin(item) {
        return axios.post('api/storeLogin', item);
    }
   

    listPersonasReparticion(id) {
        return axios.get('api/PersonaSistema/listReparticionPersona?Persona='+id);
    }

    listSistemasPersona(id) {
        return axios.get('api/PersonaSistema/listSistPer?email='+id);
    }

    listReparticionesNumero(id) {
        return axios.get('api/PersonaSistema/listReparticionesNumero?id=' + id);
    }

    select2Persona(q) {
        return axios.get('api/Persona/select2?q=' + q);
    }


    showConversacion(id) {
        return axios.get('api/Conversacion/show?id=' + id);
    }

    indexConversacion() {
        return axios.defaults.baseURL + 'api/Conversacion/index';
    }

    listConversacion(id) {
        return axios.get('api/Conversacion/list?idPersona=' + id);
    }

    storeConversacion(item) {
        return axios.post('api/Conversacion/store', item);
    }

    destroyConversacion(item) {
        return axios.post('api/Conversacion/destroy', item);
    }

    verificarConversacion(item) {
        return axios.post('api/Conversacion/verificar', item);
    }



    showMensaje(id) {
        return axios.get('api/Mensaje/show?id=' + id);
    }

    indexMensaje() {
        return axios.defaults.baseURL + 'api/Mensaje/index';
    }

    listMensaje(id) {
        return axios.get('api/Mensaje/list?id=' + id);
    }

    storeMensaje(item) {
        return axios.post('api/Mensaje/store', item);
    }

    destroyMensaje(item) {
        return axios.post('api/Mensaje/destroy', item);
    }





}